import { Fragment, HTMLAttributes } from 'react'

interface CoverLetterListItemMobileContentProps {
  content: string
  highlight?: string[]
  typographyProps?: HTMLAttributes<HTMLParagraphElement>
}

const CoverLetterListItemMobileContent = ({
  content,
  highlight,
  typographyProps,
}: CoverLetterListItemMobileContentProps) => {
  if (highlight && highlight.length > 0) {
    return (
      <>
        {highlight.map((item: string, index) => {
          return (
            <Fragment key={index}>
              <p
                dangerouslySetInnerHTML={{ __html: item }}
                {...typographyProps}
              />
            </Fragment>
          )
        })}
      </>
    )
  }
  return <p {...typographyProps}>{content}</p>
}

export default CoverLetterListItemMobileContent
